var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container rounded-t-3xl wrap auth h-full w-full"},[_c('h2',{staticClass:"text-align-center mb-8"},[_vm._v(_vm._s(_vm.$t('password.createTitle')))]),_c('NewPassword',{attrs:{"is-old-pwd-needed":false,"section-message":_vm.pwdMessage,"processing":_vm.processing},on:{"submit":_vm.sendReset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }